import styled from 'styled-components'
import Box, { BoxProps } from 'components/shared/Box'
import Text, { TextProps } from 'components/shared/Text'
import { respondAbove } from 'styles/mediaQueries'

export const VoucherPreviewWrapper = styled(Box)`
    width: 296px;
    height: 192px;
    margin-left: auto;
    margin-right: auto;
    border-radius: 10px;
    border: 2px solid ${({ theme }) => theme.colors.grayscale_400};
    overflow: hidden;

    @media ${respondAbove.md} {
        width: 384px;
        height: 248px;
    }
`

export const VoucherPreviewLeft = styled(Box)<BoxProps>`
    min-width: 158px;
    height: 100%;

    @media ${respondAbove.md} {
        min-width: 210px;
    }
`

export const VoucherPreviewLeftWrapper = styled(Box)<BoxProps>`
    align-items: center;
`

export const VoucherPreviewRight = styled(Box)`
    min-width: 138px;
    height: 100%;
    padding-top: 12px;

    @media ${respondAbove.md} {
        min-width: 163px;
        padding-top: 16px;
    }
`
export const VoucherPreviewTitle = styled(Text)`
    font-family: ${({ theme }) => theme.fonts.title_docs};
    font-size: 16px;
    line-height: 20px;

    @media ${respondAbove.md} {
        font-size: 20px;
        line-height: 26px;
    }
`

export const VoucherPreviewDate = styled(Text)<TextProps>`
    font-family: ${({ theme }) => theme.fonts.title_docs};
    font-size: 11px;
    line-height: 20px;

    @media ${respondAbove.md} {
        font-size: 14px;
        line-height: 26px;
    }
`

export const VoucherPreviewHks = styled(Text)<TextProps>`
    margin-top: 5px;
    font-family: ${({ theme }) => theme.fonts.title_docs};
    font-size: 10px;
    line-height: 18px;
    word-break: break-all;

    @media ${respondAbove.md} {
        margin-top: 8px;
        font-size: 13px;
        line-height: 23px;
    }
`
export const VoucherPreviewCopy = styled(Text)`
    width: 100%;
    text-align: center;
    font-family: ${({ theme }) => theme.fonts.title_common};
    font-size: 11px;
    line-height: 15px;

    @media ${respondAbove.md} {
        font-size: 14px;
        line-height: 20px;
    }
`
export const VoucherPreviewInfo = styled(Text)`
    font-family: ${({ theme }) => theme.fonts.text_docs};
    font-size: 5px;
    line-height: 10px;

    @media ${respondAbove.md} {
        font-size: 7px;
    }
`

export const VoucherPreviewQRCode = styled(Box)<BoxProps>`
    align-items: center;
    margin-top: auto;
    text-align: center;

    img {
        width: 84px;
        height: 84px;

        @media ${respondAbove.md} {
            width: 110px;
            height: 110px;
        }
    }
`
